import { useState, useEffect } from 'react';

/**
 * 监听浏览器窗口大小变化的自定义Hook
 * @returns {Object} 返回包含窗口宽度和高度的对象
 */
const useWindowSize = () => {
    // 初始化状态，使用window.innerWidth和window.innerHeight获取初始值
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        // 定义处理窗口大小变化的函数
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        // 添加事件监听器
        window.addEventListener('resize', handleResize);

        // 立即调用一次以处理初始尺寸
        handleResize();

        // 组件卸载时移除事件监听器，防止内存泄漏
        return () => window.removeEventListener('resize', handleResize);
    }, []); // 空依赖数组确保只在组件挂载和卸载时运行

    return windowSize;
};

export default useWindowSize;